import React, { Component } from "react";

class ModalContainer extends Component {
  render() {
    return <div id={"modalContainerId"}></div>;
  }
}

export default React.memo(ModalContainer);
